import {
  CREATE_SUBSCRIPTION,
  GET_SUBSCRIPTION,
  GET_SUBSCRIPTIONS,
  SET_ALL_SUBSCRIPTIONS,
  SET_ALL_SUBSCRIPTION_SELECT,
  UPDATE_SUBSCRIPTION,
} from "../../reducerTypes";

const initialState = {
  getData: {},
  getList: [],
  selectData: [],
};

const subscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_SUBSCRIPTIONS:
      return {
        ...state,
        getList: action.payload,
      };
    case GET_SUBSCRIPTIONS:
      return {
        ...state,
        getList: action.payload,
      };
    case SET_ALL_SUBSCRIPTION_SELECT:
      const contentData = action.payload ? action.payload : [];
      const selectData = [];
      contentData.map((data) => {
        selectData.push({
          value: data.id,
          label: `${data.title}`,
          price: data.price,
        });
      });
      return {
        ...state,
        selectData: selectData,
      };
    case CREATE_SUBSCRIPTION:
      return {
        ...state,
        getData: action.payload,
      };
    case GET_SUBSCRIPTION:
      return {
        ...state,
        getData: action.payload,
      };
    case UPDATE_SUBSCRIPTION:
      return {
        ...state,
        getData: action.payload,
      };
    default:
      return state;
  }
};

export default subscriptionReducer;
